import { render, staticRenderFns } from "./CurrencyCoin.vue?vue&type=template&id=f7cdfb16"
import script from "./CurrencyCoin.vue?vue&type=script&lang=js"
export * from "./CurrencyCoin.vue?vue&type=script&lang=js"
import style0 from "./CurrencyCoin.vue?vue&type=style&index=0&id=f7cdfb16&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports